module.exports = __webpack_public_path__ + "static/media/wlx.2d75ed57.png";